import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import myaxios from './axios'; //axios的全局配置
import Vant from 'vant'
import 'vant/lib/index.css';
import { Dialog } from 'vant';
import { Toast } from 'vant';
import VueMeta from 'vue-meta';
Vue.use(Vant)
Vue.use(Dialog);
Vue.use(Toast);
Vue.config.productionTip = false

// 给全局Vue实例对象添加axios属性
Vue.prototype.$axios = myaxios;

Vue.use(VueMeta);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
